import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { LoginComponent } from './pages/login/login.component';

import { AboutFenacoIdComponent } from './pages/about-fenaco-id/about-fenaco-id.component';
import { AccountComponent } from './pages/account/account.component';
import { EmailVerificationComponent } from './pages/email-verification/email-verification.component';
import { ErrorComponent } from './pages/error/error.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ChangeEmailFlowComponent } from './pages/change-email-flow/change-email-flow.component';
import { ImprintComponent } from './pages/imprint/imprint.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const routes: Routes = [
  {
    path: 'email-verification',
    component: EmailVerificationComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    // TODO(CIAM-418): the Benutzerkonto is an Auth0 Form now. pages/profile and
    // components/profile-content (with updatePorfileEndpoint and the c3a4m /update-profile
    // endpoint) are retired, not routed, and kept for an easy rollback: put ProfileComponent
    // back here. Delete them once the Form is in production.
    path: '',
    component: AccountComponent,
    canActivate: [AuthGuard],
  },
  {
    // TODO(CIAM-420, FU-16): "Passwort ändern" mails Auth0's reset link now. Kept for an
    // easy rollback; delete pages/change-password, components/change-password-content,
    // changePasswordEndpoint and the changePassword texts (except backCta, used by
    // change-email), and redirect this path to '', once the reset link is in production.
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'about-fenaco-login',
    component: AboutFenacoIdComponent,
  },
  {
    path: 'change-email',
    component: ChangeEmailFlowComponent,
    canActivate: [AuthGuard],
  },
  { path: 'imprint', component: ImprintComponent },
  { path: 'privacy', component: PrivacyPolicyComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {}),
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'de',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [RouterModule, ReactiveFormsModule, FormsModule, TranslateModule],
})
export class AppRoutingModule {}
